import useSWR from 'swr';

import axios, { endpoints } from 'src/lib/axios';

// Nº de solicitudes de reputación "nuevas" (activas), para el badge del menú.
export function useReputationNewCount() {
  const { data, mutate } = useSWR(
    endpoints.reputationRequests.countNew,
    async (url: string) => {
      const res = await axios.get(url);
      return (res.data?.count as number) ?? 0;
    },
    { revalidateOnFocus: false, refreshInterval: 60000 }
  );

  return { count: data ?? 0, refresh: mutate };
}
